/** @jsx jsx */
// import { jsx, ThemeProvider } from "theme-ui";
import { jsx } from "theme-ui";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { DefaultButton } from "office-ui-fabric-react";
import { selectorSrcmProfile } from "../state/selectors";
import unsetUser from "../state/actions/unsetUser";
// import { useGlobals } from "../globals";

const getMandatoryEnv = require("sites-common/utils/getMandatoryEnv");

const { keycloakConfig } = getMandatoryEnv(["keycloakConfig"]);

const SignOutButton = ({ btn, btnText }) => {
  const srcmProfile = useSelector(selectorSrcmProfile);
  const dispatch = useDispatch();
  const oneauthLogout = React.useCallback(async () => {
    const params = keycloakConfig;
    if (typeof window !== "undefined") {
      const { userLogout } = await import("hfnauth/main");
      await userLogout(params);
      dispatch(unsetUser());
      window.location.href = "/";
      return true;
    }
    return false;
  }, [dispatch]);

  if (srcmProfile) {
    return btn ? (
      <div
        onClick={() => oneauthLogout()}
        onKeyDown={() => oneauthLogout()}
        tabIndex={0}
        role="button"
      >
        {btn}
      </div>
    ) : (
      <DefaultButton onClick={() => oneauthLogout()} text={btnText} />
    );
  }
  return null;
};
SignOutButton.propTypes = {
  btn: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  btnText: PropTypes.string,
};
SignOutButton.defaultProps = {
  btn: null,
  btnText: "Sign Out",
};

export default SignOutButton;
